export const EChatTab = {
  Support: 'support',
  WithSeller: 'with-seller',
} as const;
export type TChatTab = (typeof EChatTab)[keyof typeof EChatTab];

export function parseChatTab(value: string): TChatTab | null {
  return Object.values(EChatTab).includes(value as TChatTab)
    ? (value as TChatTab)
    : null;
}
